import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_8: FaireProductEntity = {
  token: "nyc-snack-8",
  type: "product",
  name: "Organic Energy Bites",
  brandName: "Brooklyn Fuel",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/96ed897d11d6e42b27e84341c0c32d3b77de10e57c5357317fb23ec10323e2a3.webp",
  priceDollars: 14,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/96ed897d11d6e42b27e84341c0c32d3b77de10e57c5357317fb23ec10323e2a3.webp",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 5,
    depth: 2,
  },
  description: "Plant-based energy bites with dates, nuts, and superfoods",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "organic", "vegan", "healthy"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
